module.exports = __webpack_public_path__ + "img/eth.2798303b.svg";